import React, { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";
import CallScenerios from "./CallScenerios";
import ContinueCancelBooking from "./ContinueCancelBooking";
import ContinueComplaint from "./ContinueComplaint";
import ContinueFranchiseEnquiry from "./ContinueFranchiseEnquiry";
import ContinueMessageOperator from "./ContinueMessageOperator";
import ContinueServiceCall from "./ContinueServiceCall";
import ReferallEnquiry from "./ReferallEnquiry";
import ReferallPage from "./ReferallPage";
import ReSchedule from "./ReSchedule";
import SaveCall from "./SaveCall";
import SelectOrganization from "./SelectOrganization";
import SelectPostCode from "./SelectPostCode";
import ServiceRequired from "./ServiceRequired";
import useStyles from "./style";
import TopInfoBox from "./topInfoBox";
import { httpClient } from "appUtility/Api";
import qs from "qs";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import ContinueDeclineOperator from "./ContinueDeclineOperator";
import SelectFranchiseChange from "./SelectFranchiseChange";
import ContinueFranchiseChange from "./ContinueFranchiseChange";
import ContinueEnquiry from "./ContinueEnquiry";

const login = localStorage.getItem("login");

const lodgeCall2 = () => {
  const classes = useStyles();
  var loginData = JSON.parse(login);

  // STEPS
  const [step, setStep] = useState(1);
  const [serviceStep, setServiceStep] = useState("");
  const [cancelStep, setCancelStep] = useState(0);
  const [messageStep, setMessageStep] = useState("");
  const [changeSuburbStep, setChangeSuburbState] = useState(0);
  const [enquiryStep, setEnquiryStep] = useState(0);
  const [adEnquiryStep, setAdEnquiryStep] = useState(0);
  const [complaintStep, setComplaintStep] = useState(0);
  const [declineStep, setDeclineStep] = useState(0);
  const [saveStep, setSaveStep] = useState(0);
  const [endCall, setEndCall] = useState(0);
  // STEPS

  const [boxInfo, setBoxInfo] = useState("");
  const [radios, setRadios] = useState("Service Required");
  const [serviceSelect, setServiceSelect] = useState("Wash only");
  const [postCode, setPostCode] = useState("");
  const [suburb, setSuburb] = useState("");
  const [franchise, setFranchise] = useState("");
  const [operatorName, setOperatorName] = useState("");
  const [state, setState] = useState("");
  const [stateID, setStateID] = useState("");
  const [suspendedFranchisee, setSuspendedFranchisee] = useState({});
  const [companyID, setCompanyID] = useState("");
  const [showResetButton, setShowResetButton] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [franchiseList, setFranchiseList] = useState([]);
  const [suburbCurrent, setSuburbCurrent] = useState([]);
  const [suburbStackList, setSuburbStackList] = useState([]);
  const [currentFranchiseList, setCurrentFranchiseList] = useState([]);
  const [newCallScenarioSelected, setNewCallScenarioSelected] = useState(false);
  const [previousForwardedScenario, setPreviousForwardedScenario] = useState(
    ""
  ); // The scenario for which we have moved to the next step
  const [inputValue, setInputValue] = useState("");
  const [currentSelectedFranchise, setCurrentSelectedFranchise] = useState(
    null
  ); // In SelectedPostCode component, used to set currently selected franchise when we are at tab FRANCHISE
  const [franchiseInput, setFranchiseInput] = useState("");
  const [franchiseSuburbsList, setFranchiseSuburbsList] = useState([]);
  const [franchiseSuburb, setFranchiseSuburb] = useState("");
  const [callRefNumber, setCallRefNumber] = useState("");
  const [postCodeValid, setPostCodeValid] = useState(false);
  const [shouldReset, setShouldReset] = useState(false);

  // value of tab on select postcode
  const [value, setValue] = useState(() => {
    return Number(localStorage.getItem("selectedTab")) || 0;
  });

  const [enquiryDetails, setEnquiryDetails] = useState({
    // customerName: "",
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    address: "",
    message: "",
    hearingSource: "",
    other: "",
  });
  const [enquiryPressed, setEnquiryPressed] = useState({
    // customerName: false,
    firstName: false,
    lastName: false,
    phoneNumber1: false,
    phoneNumber2: false,
    postCode: false,
    suburb: false,
    address: false,
    message: false,
    hearingSource: false,
    other: false,
  });
  const [messageOperatorDetails, setMessageOperatorDetails] = useState({
    operatorName: "",
    // customerName: "",
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    postCode: "",
    suburb: "",
    address: "",
    message: "",
  });
  const [messageOperatorPressed, setMessageOperatorPressed] = useState({
    // customerName: false,
    firstName: false,
    lastName: false,
    phoneNumber1: false,
    phoneNumber2: false,
    postCode: false,
    suburb: false,
    address: false,
    message: false,
  });
  const [callerDetails, setCallerDetails] = useState({
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    address: "",
    hearingSource: "",
    arrangeCall: "",
    other: "",
    comment: "",
     petBreed: "",
    message: "",
  });
  const [callerPressed, setCallerPressed] = useState({
    firstName: false,
    lastName: false,
    phoneNumber1: false,
    phoneNumber2: false,
    postCode: false,
    suburb: false,
    address: false,
    message: false,
    hearingSource: false,
    arrangeCall: false,
    other: "",
    comment: "",
  });

  const [saveCaller, setSaveCaller] = useState({
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    address: "",
    suburb: "",
    postCode: "",
  });
  const [saveCallerPressed, setSaveCallerPressed] = useState({
    firstName: false,
    lastName: false,
    phoneNumber1: false,
    phoneNumber2: false,
    postCode: false,
    suburb: false,
    address: false,
  });

  const [franchiseChangeFocus, setFranchiseChangeFocus] = useState({
    franchise: false,
    message: false,
  });

  useEffect(() => {
    // setRadios("Service Required");
    // setServiceSelect("");
    if (newCallScenarioSelected || shouldReset) {
      setSuburbList([]);
      setFranchiseList([]);

      setPostCode("");
      setSuburb("");
      setFranchise("");
      setOperatorName("");
      setState("");
      setStateID("");
      setSuspendedFranchisee({});
      setEnquiryDetails({
        // customerName: "",
        firstName: "",
        lastName: "",
        phoneNumber1: "",
        phoneNumber2: "",
        address: "",
        message: "",
        hearingSource: "",
        other: "",
      });
      setMessageOperatorDetails({
        operatorName: "",
        // customerName: "",
        firstName: "",
        lastName: "",
        phoneNumber1: "",
        phoneNumber2: "",
        suburb: "",
        message: "",
      });
      setMessageOperatorPressed({
        // customerName: "",
        firstName: "",
        lastName: "",
        phoneNumber1: "",
        phoneNumber2: "",
        postCode: "",
        suburb: "",
        address: "",
        message: "",
      });
      setCallerDetails({
        firstName: "",
        lastName: "",
        phoneNumber1: "",
        phoneNumber2: "",
        address: "",
        hearingSource: "",
        arrangeCall: "",
        other: "",
        comment: "",
         petBreed: "",
      });
      setSaveCaller({
        firstName: "",
        lastName: "",
        phoneNumber1: "",
        phoneNumber2: "",
        address: "",
        suburb: "",
        postCode: "",
      });
      setEnquiryPressed({
        // customerName: false,
        firstName: false,
        lastName: false,
        phoneNumber1: false,
        phoneNumber2: false,
        address: false,
        message: false,
        hearingSource: false,
        other: false,
      });
      setMessageOperatorPressed({
        // customerName: false,
        firstName: false,
        lastName: false,
        phoneNumber1: false,
        phoneNumber2: false,
        postCode: false,
        suburb: false,
        address: false,
        message: false,
      });
      setCallerPressed({
        firstName: false,
        lastName: false,
        phoneNumber1: false,
        phoneNumber2: false,
        address: false,
        hearingSource: false,
        arrangeCall: false,
        other: "",
        comment: "",
      });
      setSaveCallerPressed({
        firstName: false,
        lastName: false,
        phoneNumber1: false,
        phoneNumber2: false,
        postCode: false,
        suburb: false,
        address: false,
      });
    }
  }, [step === 2]);

  // useEffect(() => {
  //   window.addEventListener("keydown", function(e) {
  //     if(e.key === "Backspace"){
  //       handleBack()
  //     }
  //   });

  // },[])

  const handleChangeSave = (e) => {
    const { name, value } = e.target;

    let newVal;
    if (name === "phoneNumber1" || name === "phoneNumber2") {
      newVal = value
        .replace(/[&\/\\#, +()$~%.'":*?<>{}@!^]/g, "")
        .toString()
        .slice(0, 10);
    }

    setSaveCaller({
      ...saveCaller,
      [name]:
        name === "phoneNumber1" || name === "phoneNumber2" ? newVal : value,
    });
  };

  const handleChangeSavePressed = (e) => {
    const { name, value } = e.target;
    setSaveCallerPressed({
      [name]: name ? true : false,
    });
  };

  const handleInfo = (data) => {
    setBoxInfo(data);
    setStep(2);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newVal;
    if (name === "suburb") {
      setSuburb(value);
    }
    if (name === "postCode") {
      setPostCode(value);
    }
    if (name === "state") {
      setState(value);
    }
    if (name === "phoneNumber1" || name === "phoneNumber2") {
      newVal = value
        .replace(/[&\/\\#, +()$~%.'":*?<>{}@!^]/g, "")
        .toString()
        .slice(0, 10);
    }
    setCallerDetails({
      ...callerDetails,
      [name]:
        name === "phoneNumber1" || name === "phoneNumber2" ? newVal : value,
    });
  };

  const handleEnquiryChange = (e) => {
    const { name, value } = e.target;
    let newVal;
    if (name === "phoneNumber1" || name === "phoneNumber2") {
      newVal = value
        .replace(/[&\/\\#, +()$~%.'":*?<>{}@!^]/g, "")
        .toString()
        .slice(0, 10);
    }
    setEnquiryDetails({
      ...enquiryDetails,
      [name]:
        name === "phoneNumber1" || name === "phoneNumber2" ? newVal : value,
    });
  };
  const handleEnquiryPress = (e) => {
    const { name, value } = e.target;
    // if (e.key === "Enter") {
    setEnquiryPressed({
      // ...enquiryPressed,
      [name]: name ? true : false,
    });
  };

  const handleCallerFocus = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setCallerPressed({
      // ...callerPressed,
      [name]: name ? true : false,
    });
  };

  const handleFranchiseChangeFocus = (e) => {
    const { name } = e.target;
    setFranchiseChangeFocus((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const handleFranchiseChangeFocusOut = (e) => {
    const { name } = e.target;
    setFranchiseChangeFocus((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const handleChangeOperator = (e) => {
    const { name, value } = e.target;
    let newVal;
    if (name === "phoneNumber1" || name === "phoneNumber2") {
      newVal = value
        .replace(/[&\/\\#, +()$~%.'":*?<>{}@!^]/g, "")
        .toString()
        .slice(0, 10);
    }
    setMessageOperatorDetails({
      ...messageOperatorDetails,
      [name]:
        name === "phoneNumber1" || name === "phoneNumber2" ? newVal : value,
    });
  };

  const handlePressOperator = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setMessageOperatorPressed({
      // ...messageOperatorPressed,
      [name]: name ? true : false,
    });
  };

  const handleRadioChange = (e) => {
    setRadios(e.target.value);
    setNewCallScenarioSelected(radios !== e.target.value);
    localStorage.removeItem("selectedTab"); // Clear storage after completion
    setValue(0);
  };
  const handleServiceChange = (e) => {
    setServiceSelect(e.target.value);
  };

  const handlePostCode = (e) => {
    setPostCode(e.target.value);
  };

  const handleSuburb = (e) => {
    setSuburb(e.target.value);
  };

  const handleFranchise = (e) => {
    setFranchise(e.target.value);
  };

  const handleBack = () => {
    setStep(step - 1);
  };
  const handleNext = () => {
    setStep(step + 1);
  };

  const handleNone = () => {
    setStep(step);
  };

  const handleNextService = () => {
    setStep(step + 1);
    setServiceStep(1);
  };
  const handleBackService = () => {
    setStep(step - 1);
    setServiceStep(serviceStep - 1);

    if (step === 4 && serviceStep === 1) {
      const savedTab = Number(localStorage.getItem("selectedTab"));
      setValue(savedTab);
    }
  };
  const handleContinueService = () => {
    setStep(step + 1);
    setServiceStep(serviceStep + 1);
    localStorage.setItem("selectedTab", value);
  };

  const handleBackChangeSuburb = () => {
    setStep(step - 1);
    setChangeSuburbState(changeSuburbStep - 1);
  };

  const handleBackAd = () => {
    setStep(step - 1);
    setAdEnquiryStep(adEnquiryStep - 1);
  };

  const handleBackEq = () => {
    setStep(step - 1);
    setEnquiryStep(enquiryStep - 1);
  };

  const handleContinueCancel = () => {
    setStep(step + 1);
    setCancelStep(cancelStep + 1);

    localStorage.setItem("selectedTab", value);
  };

  const handleBackCancel = () => {
    setStep(step - 1);
    setCancelStep(cancelStep - 1);

    if (step === 3 && radios === "Cancel Booking") {
      const savedTab = Number(localStorage.getItem("selectedTab"));
      setValue(savedTab);
    }
  };

  const handleContinueMessage = () => {
    setStep(step + 1);
    setMessageStep(1);

    localStorage.setItem("selectedTab", value);
  };

  const handleBackMessage = () => {
    setStep(step - 1);
    setMessageStep(messageStep - 1);

    if (step === 3 && radios === "Message For Operator") {
      const savedTab = Number(localStorage.getItem("selectedTab"));
      setValue(savedTab);
    }
  };

  const handleContinueChangeSuburb = () => {
    setStep(step + 1);
    setChangeSuburbState(changeSuburbStep + 1);
  };

  const handleContinueEnquiry = () => {
    setStep(step + 1);
    setEnquiryStep(enquiryStep + 1);
  };

  const handleContinueAdEnquiry = () => {
    setStep(step + 1);
    setAdEnquiryStep(adEnquiryStep + 1);
  };

  const handleContinueComplaint = () => {
    setStep(step + 1);
    setComplaintStep(complaintStep + 1);

    localStorage.setItem("selectedTab", value);
  };

  const handleBackComplaint = () => {
    setStep(step - 1);
    setComplaintStep(complaintStep - 1);

    if (step === 3 && radios === " Complaint") {
      const savedTab = Number(localStorage.getItem("selectedTab"));
      setValue(savedTab);
    }
  };
  const handleContinueDecline = () => {
    setStep(step + 1);
    setDeclineStep(declineStep + 1);

    localStorage.setItem("selectedTab", value);
  };
  const handleBackDecline = () => {
    setStep(step - 1);
    setDeclineStep(declineStep - 1);

    if (step === 3 && radios === "Declined to Proceed") {
      const savedTab = Number(localStorage.getItem("selectedTab"));
      setValue(savedTab);
    }
  };
  const handleNextCancel = () => {};

  const handleSubmitService = (e) => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: callerDetails.firstName,
      lastName: callerDetails.lastName,
      address: callerDetails.address,
      phone: callerDetails.phoneNumber1,
      phone2: callerDetails.phoneNumber2,
      suburb: typeof suburb === "object" ? suburb.suburbName : suburb,
      stateID: stateID,
      service_area_postcode: postCode,
      company_id: franchise.companyID,
      leadNotes: callerDetails.other,
      interestedService: serviceSelect,
      referredBy: callerDetails.hearingSource,
      notes: callerDetails.comment,
      petBreed: callerDetails.petBreed,
      messageType: "service_required",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleReset = () => {
    setStep(1);
    setServiceStep(0);
    setCancelStep(0);
    setComplaintStep(0);
    setDeclineStep(0);
    setEnquiryStep(0);
    setAdEnquiryStep(0);
    setChangeSuburbState(0);
    setShowResetButton(false);
    setSuspendedFranchisee({});
  };

  const handleSubmitCancelBooking = () => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: callerDetails.firstName,
      lastName: callerDetails.lastName,
      address: callerDetails.address,
      phone: callerDetails.phoneNumber1,
      phone2: callerDetails.phoneNumber2,
      notes: callerDetails.message || "",
      suburb: typeof suburb === "object" ? suburb.suburbName : suburb,
      stateID: stateID,
      service_area_postcode: postCode,
      company_id: franchise.companyID,
      reschedule: callerDetails.arrangeCall,
      messageType: "cancel_booking",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleSubmitMessageOperator = () => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: messageOperatorDetails.firstName,
      lastName: messageOperatorDetails.lastName,
      phone: messageOperatorDetails.phoneNumber1,
      phone2: messageOperatorDetails.phoneNumber2,
      notes: messageOperatorDetails.message || "",
      address: messageOperatorDetails.address,
      suburb: typeof suburb === "object" && suburb ? suburb.suburbName : suburb,
      stateID: stateID,
      service_area_postcode: postCode,
      company_id: franchise.companyID,
      messageType: "message_for_operator",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleDeclinedSubmit = () => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: messageOperatorDetails.firstName,
      lastName: messageOperatorDetails.lastName,
      phone: messageOperatorDetails.phoneNumber1,
      phone2: messageOperatorDetails.phoneNumber2,
      notes: messageOperatorDetails.message || "",
      suburb: typeof suburb === "object" ? suburb.suburbName : suburb,
      stateID: stateID,
      address: messageOperatorDetails.address,
      service_area_postcode: postCode,
      company_id: "",
      messageType: "declined_to_proceed",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleSubmitEnquiry = (type) => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: enquiryDetails.firstName,
      lastName: enquiryDetails.lastName,
      phone: enquiryDetails.phoneNumber1,
      phone2: enquiryDetails.phoneNumber2,
      address: enquiryDetails.address || "",
      notes: enquiryDetails.other || "",
      referredBy: "",
      notes: enquiryDetails.message || "",
      suburb: suburb,
      stateID: stateID || "",
      service_area_postcode: postCode,
      company_id: "",
      messageType: type,
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleSubmitComplaint = () => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      firstName: enquiryDetails.firstName,
      lastName: enquiryDetails.lastName,
      phone: enquiryDetails.phoneNumber1,
      phone2: enquiryDetails.phoneNumber2,
      address: enquiryDetails.address,
      suburb: typeof suburb === "object" ? suburb.suburbName : suburb,
      stateID: stateID,
      service_area_postcode: postCode,
      company_id: franchise.companyID,
      notes: enquiryDetails.message || "",
      messageType: "complaint",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleSubmitFranchiseChange = () => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      // firstName: enquiryDetails.firstName,
      // lastName: enquiryDetails.lastName,
      // phone: enquiryDetails.phoneNumber1,
      // phone2: enquiryDetails.phoneNumber2,
      // address: enquiryDetails.address,

      // suburb: suburb,
      // stateID: stateID,
      // service_area_postcode: postCode,
      // company_id: companyID,
      company_id: franchise.companyID,
      notes: enquiryDetails.message,
      messageType: "franchisee_calling_to_change_suburb",
    };

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const handleSaveCall = () => {
    setStep(step + 1);
    setSaveStep(1);
    setEndCall(1);
  };

  const handleBackEndCall = () => {
    setStep(step - 1);
    setSaveStep(0);
    setEndCall(0);
  };

  const getMessageType = (radios) => {
    switch (radios) {
      case "Service Required":
        return "service_required";

      case "Cancel Booking":
        return "cancel_booking";

      case "Message For Operator":
        return "message_for_operator";

      case "Franchisee calling to change suburb":
        return "franchisee_calling_to_change_suburb";

      case "Advertising Enquiry":
        return "advertising_enquiry";

      case "Franchise Enquiry":
        return "franchise_enquiry";

      case "Complaint":
        return "complaint";

      case "Declined to Proceed":
        return "declined_to_proceed";

      case "Other":
        return "other";

      default:
        return "";
    }
  };

  const handleEndCall = (caller = {}) => {
    let params = {
      userID: loginData.uid,
      userCode: loginData.aCode,
      appID: 1,
      organization: boxInfo === "Blue Wheelers" ? 1 : 2,
      firstName: saveCaller.firstName || caller.firstName || "",
      lastName: saveCaller.lastName || caller.lastName || "",
      phone: saveCaller.phoneNumber1 || caller.phoneNumber1 || "",
      phone2: saveCaller.phoneNumber2 || caller.phoneNumber2 || "",
      service_area_postcode: postCode || "",
      address: saveCaller.address || caller.address || "",
      suburb: (typeof suburb === "object" ? suburb.suburbName : suburb) || "",
      message: caller.message || "",
      messageType: getMessageType(radios),
      endCall: 1,
    };

    if (radios === "Service Required") {
      params.interestedService = serviceSelect;

      if (caller.hearingSource) {
        params.referredBy = caller.hearingSource;
      }
    }

    if (radios === "Cancel Booking") {
      params.reschedule = caller.arrangeCall;
    }

    if (radios === "Franchisee calling to change suburb") {
      params.company_id = franchise.companyID;
    }

    httpClient
      .post(
        "saveCallLog2.php",
        qs.stringify({
          action: "save_call",
          source: params,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          setShowResetButton(true);
          setShouldReset(true);
          setCallRefNumber(data.referenceNumber);
          NotificationManager.success(data.message);
        } else {
          NotificationManager.warning(data.message);
        }
      });
  };

  const continueEnquiryProps = {
    handleEnquiryChange: handleEnquiryChange,
    handleEnquiryPress: handleEnquiryPress,
    enquiryDetails: enquiryDetails,
    enquiryPressed: enquiryPressed,
    suspendedFranchisee: suspendedFranchisee,
    handleChange: handleChange,
    handleBack: handleBackEq,
    handleSubmit: handleSubmitEnquiry,
    showResetButton: showResetButton,
    handleReset: handleReset,
    callRefNumber: callRefNumber,
    postCode: postCode,
    suburb: suburb,
    suburbList: suburbList,
    setSuburbList: setSuburbList,
    setPostCode: setPostCode,
    setSuburb: setSuburb,
    handleSuburb: handleSuburb,
    handlePostCode: handlePostCode,
    postCodeValid: postCodeValid,
    setPostCodeValid: setPostCodeValid,
    handleEndCall: handleEndCall,
  };

  const warningText =
    "If the caller cannot provide a serviced postcode/suburb, please advise we are unable to process the message request.";

  return (
    <>
      {step === 1 && <SelectOrganization handleInfo={handleInfo} />}
      {step === 2 && (
        <CallScenerios
          step={step}
          header={
            boxInfo === "Blue Wheelers"
              ? `Welcome to Blue Wheelers Wash,clip and groom. How may I help you ?`
              : `Welcome to Dash Dog. How may I help you ?`
          }
          radios={radios}
          handleRadioChange={handleRadioChange}
          handleBack={handleBack}
          // handleNext={
          //   radios === "Franchisee calling to change suburb"
          //     ? handleNone
          //     : handleNext
          // }
          handleNext={handleNext}
        />
      )}
      {step === 3 && radios === "Service Required" && (
        <ServiceRequired
          serviceSelect={serviceSelect}
          handleServiceChange={handleServiceChange}
          handleBack={handleBack}
          handleNext={handleNextService}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
        />
      )}

      {/* Service Required */}
      {step === 4 && serviceStep === 1 && (
        <SelectPostCode
          currentOrganization={boxInfo}
          serviceRequired={true}
          handlePostCode={handlePostCode}
          setPostCode={setPostCode}
          handleSuburb={handleSuburb}
          handleFranchise={handleFranchise}
          setSuspendedFranchisee={setSuspendedFranchisee}
          postCode={postCode}
          suburb={suburb}
          franchise={franchise}
          setState={setState}
          setStateID={setStateID}
          setCompanyID={setCompanyID}
          setSuburb={setSuburb}
          setFranchise={setFranchise}
          setOperatorName={setOperatorName}
          handleBack={handleBackService}
          handleContinue={handleContinueService}
          handleSaveCall={handleSaveCall}
          saveCall={true}
          stateList={stateList}
          setStateList={setStateList}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          franchiseList={franchiseList}
          setFranchiseList={setFranchiseList}
          suburbCurrent={suburbCurrent}
          setSuburbCurrent={setSuburbCurrent}
          currentFranchiseList={currentFranchiseList}
          setCurrentFranchiseList={setCurrentFranchiseList}
          suburbStackList={suburbStackList}
          setSuburbStackList={setSuburbStackList}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
          inputValue={inputValue}
          setInputValue={setInputValue}
          currentSelectedFranchise={currentSelectedFranchise}
          setCurrentSelectedFranchise={setCurrentSelectedFranchise}
          franchiseInput={franchiseInput}
          setFranchiseInput={setFranchiseInput}
          franchiseSuburbsList={franchiseSuburbsList}
          setFranchiseSuburbsList={setFranchiseSuburbsList}
          franchiseSuburb={franchiseSuburb}
          setFranchiseSuburb={setFranchiseSuburb}
          handleEndCall={handleEndCall}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          value={value}
          setValue={setValue}
          serviceSelect={serviceSelect}
        />
      )}
      {step === 5 && serviceStep === 2 && (
        <div>
          <ContinueServiceCall
            handleChange={handleChange}
            callerDetails={callerDetails}
            handleCallerFocus={handleCallerFocus}
            callerPressed={callerPressed}
            postCode={postCode}
            state={state}
            suburb={suburb}
            suburbList={suburbList}
            setSuburbList={setSuburbList}
            setPostCode={setPostCode}
            setSuburb={setSuburb}
            handlePostCode={handlePostCode}
            handleSuburb={handleSuburb}
            suspendedFranchisee={suspendedFranchisee}
            operatorName={operatorName}
            handleBack={handleBackService}
            handleContinue={handleContinueService}
            postCodeValid={postCodeValid}
            setPostCodeValid={setPostCodeValid}
            handleEndCall={handleEndCall}
            handleReset={handleReset}
            showResetButton={showResetButton}
            callRefNumber={callRefNumber}
          />
        </div>
      )}
      {step === 6 && serviceStep === 3 && (
        <ReferallPage
          handleChange={handleChange}
          callerDetails={callerDetails}
          handleCallerFocus={handleCallerFocus}
          callerPressed={callerPressed}
          postCode={postCode}
          state={state}
          suburb={suburb}
          operatorName={operatorName}
          handleBack={handleBackService}
          handleSubmitService={handleSubmitService}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          handleEndCall={handleEndCall}
        />
      )}
      {/* Service Required */}

      {/* Cancel Booking */}
      {step === 3 && radios === "Cancel Booking" && (
        <SelectPostCode
          currentOrganization={boxInfo}
          cancelBooking={true}
          handlePostCode={handlePostCode}
          setPostCode={setPostCode}
          handleSuburb={handleSuburb}
          handleFranchise={handleFranchise}
          setSuspendedFranchisee={setSuspendedFranchisee}
          postCode={postCode}
          suburb={suburb}
          franchise={franchise}
          setState={setState}
          setStateID={setStateID}
          setCompanyID={setCompanyID}
          setSuburb={setSuburb}
          setFranchise={setFranchise}
          setOperatorName={setOperatorName}
          handleBack={handleBack}
          handleContinue={handleContinueCancel}
          handleSaveCall={handleSaveCall}
          saveCall={true}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          franchiseList={franchiseList}
          setFranchiseList={setFranchiseList}
          suburbCurrent={suburbCurrent}
          setSuburbCurrent={setSuburbCurrent}
          currentFranchiseList={currentFranchiseList}
          setCurrentFranchiseList={setCurrentFranchiseList}
          suburbStackList={suburbStackList}
          setSuburbStackList={setSuburbStackList}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
          inputValue={inputValue}
          setInputValue={setInputValue}
          currentSelectedFranchise={currentSelectedFranchise}
          setCurrentSelectedFranchise={setCurrentSelectedFranchise}
          franchiseInput={franchiseInput}
          setFranchiseInput={setFranchiseInput}
          franchiseSuburbsList={franchiseSuburbsList}
          setFranchiseSuburbsList={setFranchiseSuburbsList}
          franchiseSuburb={franchiseSuburb}
          setFranchiseSuburb={setFranchiseSuburb}
          handleEndCall={handleEndCall}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          value={value}
          setValue={setValue}
        />
      )}

      {step === 4 && cancelStep === 1 && (
        <ContinueCancelBooking
          handleChange={handleChange}
          callerDetails={callerDetails}
          handleCallerFocus={handleCallerFocus}
          callerPressed={callerPressed}
          postCode={postCode}
          state={state}
          suburb={suburb}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          setPostCode={setPostCode}
          setSuburb={setSuburb}
          handlePostCode={handlePostCode}
          handleSuburb={handleSuburb}
          suspendedFranchisee={suspendedFranchisee}
          operatorName={operatorName}
          handleBack={handleBackCancel}
          handleContinue={handleContinueCancel}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          handleEndCall={handleEndCall}
          handleReset={handleReset}
          showResetButton={showResetButton}
          callRefNumber={callRefNumber}
        />
      )}
      {step === 5 && cancelStep === 2 && (
        <ReSchedule
          handleChange={handleChange}
          callerDetails={callerDetails}
          handleCallerFocus={handleCallerFocus}
          callerPressed={callerPressed}
          postCode={postCode}
          state={state}
          suburb={suburb}
          operatorName={operatorName}
          handleBack={handleBackCancel}
          handleSubmitCancelBooking={handleSubmitCancelBooking}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          handleEndCall={handleEndCall}
        />
      )}
      {/* Cancel Booking */}

      {/* Franchise Calling to change suburb */}
      {step === 3 && radios === "Franchisee calling to change suburb" && (
        <SelectFranchiseChange
          // setStateID={setStateID}
          // setCompanyID={setCompanyID}
          // setSuburb={setSuburb}
          setSuspendedFranchisee={setSuspendedFranchisee}
          franchise={franchise}
          setFranchise={setFranchise}
          setCompanyID={setCompanyID}
          handleContinue={handleContinueChangeSuburb}
          handleBack={handleBack}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
          handleSubmitFranchiseChange={handleSubmitFranchiseChange}
          enquiryDetails={enquiryDetails}
          handleEnquiryChange={handleEnquiryChange}
          suspendedFranchisee={suspendedFranchisee}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          handleEndCall={handleEndCall}
          franchiseChangeFocus={franchiseChangeFocus}
          handleFranchiseChangeFocus={handleFranchiseChangeFocus}
          handleFranchiseChangeFocusOut={handleFranchiseChangeFocusOut}
        />
      )}

      {/* {step === 4 && changeSuburbStep === 1 && (
        <ContinueFranchiseChange
          handleSubmitFranchiseChange={handleSubmitFranchiseChange}
          enquiryDetails={enquiryDetails}
          handleEnquiryChange={handleEnquiryChange}
          suspendedFranchisee={suspendedFranchisee}
          handleBack={handleBackChangeSuburb}
          // handleSubmitMessageOperator={handleSubmitMessageOperator}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          handleEndCall={handleEndCall}
        />
      )} */}

      {/* Franchise Calling to change suburb */}

      {/* Message for Operator */}
      {step === 3 && radios === "Message For Operator" && (
        // <MessageOperator
        //   handleChangeOperator={handleChangeOperator}
        //   messageOperatorDetails={messageOperatorDetails}
        //   messageOperatorPressed={messageOperatorPressed}
        //   handleBack={handleBack}
        //   handleContinue={handleContinueMessage}
        // />
        <SelectPostCode
          currentOrganization={boxInfo}
          messageOperator={true}
          handlePostCode={handlePostCode}
          setPostCode={setPostCode}
          handleSuburb={handleSuburb}
          handleFranchise={handleFranchise}
          setSuspendedFranchisee={setSuspendedFranchisee}
          postCode={postCode}
          suburb={suburb}
          franchise={franchise}
          setState={setState}
          setStateID={setStateID}
          setCompanyID={setCompanyID}
          setSuburb={setSuburb}
          setFranchise={setFranchise}
          setOperatorName={setOperatorName}
          handleChangeOperator={handleChangeOperator}
          messageOperatorDetails={messageOperatorDetails}
          messageOperatorPressed={messageOperatorPressed}
          handleBack={handleBack}
          handleContinue={handleContinueMessage}
          handleSaveCall={handleSaveCall}
          saveCall={true}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          franchiseList={franchiseList}
          setFranchiseList={setFranchiseList}
          suburbCurrent={suburbCurrent}
          setSuburbCurrent={setSuburbCurrent}
          currentFranchiseList={currentFranchiseList}
          setCurrentFranchiseList={setCurrentFranchiseList}
          suburbStackList={suburbStackList}
          setSuburbStackList={setSuburbStackList}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
          inputValue={inputValue}
          setInputValue={setInputValue}
          currentSelectedFranchise={currentSelectedFranchise}
          setCurrentSelectedFranchise={setCurrentSelectedFranchise}
          franchiseInput={franchiseInput}
          setFranchiseInput={setFranchiseInput}
          franchiseSuburbsList={franchiseSuburbsList}
          setFranchiseSuburbsList={setFranchiseSuburbsList}
          franchiseSuburb={franchiseSuburb}
          setFranchiseSuburb={setFranchiseSuburb}
          handleEndCall={handleEndCall}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          value={value}
          setValue={setValue}
          warningText={warningText}
          showEndCallRight
        />
      )}
      {step === 4 && messageStep === 1 && (
        <ContinueMessageOperator
          handleChangeOperator={handleChangeOperator}
          handlePressOperator={handlePressOperator}
          suburb={suburb}
          suspendedFranchisee={suspendedFranchisee}
          messageOperatorDetails={messageOperatorDetails}
          messageOperatorPressed={messageOperatorPressed}
          handleBack={handleBackMessage}
          handleSubmitMessageOperator={handleSubmitMessageOperator}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          handleEndCall={handleEndCall}
        />
      )}
      {/* Franchise Enquire */}
      {step === 3 && radios === "Franchise Enquiry" && (
        <ContinueEnquiry type="franchise_enquiry" {...continueEnquiryProps} />
      )}
      {/* Franchise Enquire */}

      {/* Advertising Enquire */}
      {step === 3 && radios === "Advertising Enquiry" && (
        <ContinueEnquiry type="advertising_enquiry" {...continueEnquiryProps} />
      )}
      {/* Advertising Enquire */}

      {/* Complaint */}
      {step === 3 && radios === "Complaint" && (
        <SelectPostCode
          currentOrganization={boxInfo}
          complaint={true}
          handlePostCode={handlePostCode}
          setPostCode={setPostCode}
          handleSuburb={handleSuburb}
          handleFranchise={handleFranchise}
          setSuspendedFranchisee={setSuspendedFranchisee}
          postCode={postCode}
          suburb={suburb}
          franchise={franchise}
          setState={setState}
          setStateID={setStateID}
          setCompanyID={setCompanyID}
          setSuburb={setSuburb}
          setFranchise={setFranchise}
          handleChange={handleChange}
          setOperatorName={setOperatorName}
          handleBack={handleBack}
          handleContinue={handleContinueComplaint}
          handleSaveCall={handleSaveCall}
          saveCall={true}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          franchiseList={franchiseList}
          setFranchiseList={setFranchiseList}
          suburbCurrent={suburbCurrent}
          setSuburbCurrent={setSuburbCurrent}
          currentFranchiseList={currentFranchiseList}
          setCurrentFranchiseList={setCurrentFranchiseList}
          suburbStackList={suburbStackList}
          setSuburbStackList={setSuburbStackList}
          radios={radios}
          setPreviousForwardedScenario={setPreviousForwardedScenario}
          inputValue={inputValue}
          setInputValue={setInputValue}
          currentSelectedFranchise={currentSelectedFranchise}
          setCurrentSelectedFranchise={setCurrentSelectedFranchise}
          franchiseInput={franchiseInput}
          setFranchiseInput={setFranchiseInput}
          franchiseSuburbsList={franchiseSuburbsList}
          setFranchiseSuburbsList={setFranchiseSuburbsList}
          franchiseSuburb={franchiseSuburb}
          setFranchiseSuburb={setFranchiseSuburb}
          handleEndCall={handleEndCall}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          value={value}
          setValue={setValue}
          continueWithoutFranchise
        />
      )}

      {step === 4 && complaintStep === 1 && (
        <ContinueComplaint
          handleEnquiryChange={handleEnquiryChange}
          handleEnquiryPress={handleEnquiryPress}
          enquiryDetails={enquiryDetails}
          enquiryPressed={enquiryPressed}
          suburb={suburb}
          state={state}
          postCode={postCode}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          setPostCode={setPostCode}
          setSuburb={setSuburb}
          handlePostCode={handlePostCode}
          handleSuburb={handleSuburb}
          suspendedFranchisee={suspendedFranchisee}
          handleChange={handleChange}
          handleBack={handleBackComplaint}
          handleSubmitComplaint={handleSubmitComplaint}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          handleEndCall={handleEndCall}
        />
      )}
      {/* Complaint */}

      {/* Declined to proceed */}
      {step === 3 && radios === "Declined to Proceed" && (
        <ContinueDeclineOperator
          handleChangeOperator={handleChangeOperator}
          handlePressOperator={handlePressOperator}
          state={state}
          postCode={postCode}
          suburb={suburb}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          setPostCode={setPostCode}
          setSuburb={setSuburb}
          handlePostCode={handlePostCode}
          handleSuburb={handleSuburb}
          messageOperatorDetails={messageOperatorDetails}
          messageOperatorPressed={messageOperatorPressed}
          handleBack={handleBackDecline}
          suspendedFranchisee={suspendedFranchisee}
          handleDeclinedSubmit={handleDeclinedSubmit}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          handleEndCall={handleEndCall}
        />
      )}
      {/* Declined to proceed */}

      {/*Save Call */}
      {saveStep === 1 && endCall === 1 && (
        <SaveCall
          saveCaller={saveCaller}
          saveCallerPressed={saveCallerPressed}
          handleChangeSave={handleChangeSave}
          handleChangeSavePressed={handleChangeSavePressed}
          handleBack={handleBackEndCall}
          handleEndCall={handleEndCall}
          showResetButton={showResetButton}
          handleReset={handleReset}
          callRefNumber={callRefNumber}
          postCode={postCode}
          suburb={suburb}
          suburbList={suburbList}
          setSuburbList={setSuburbList}
          setPostCode={setPostCode}
          setSuburb={setSuburb}
          handlePostCode={handlePostCode}
          handleSuburb={handleSuburb}
          postCodeValid={postCodeValid}
          setPostCodeValid={setPostCodeValid}
          suspendedFranchisee={suspendedFranchisee}
        />
      )}
      {/*Save Call */}

      {/* Other */}
      {step === 3 && radios === "Other" && (
        <ContinueEnquiry type="other" {...continueEnquiryProps} />
      )}
      {/* Other */}
      <NotificationContainer />
    </>
  );
};

export default lodgeCall2;
